import {useParams} from "react-router-dom";
import { PersonalMoMComponent } from "../../components/3d/personal";
import { ButtonContainer } from "../../components/organisms/ButtonContainer";
import { Instructions } from "../../components/organisms/Instructions";

export const PersonalSpace = () => {
  const {space} = useParams();

  return (
    <>
      <div>
        <div className={space === "hexa" ? "col-md-9" : ""}>
          <PersonalMoMComponent/>
          <ButtonContainer isMomGallery showFeedback />
          <Instructions />
        </div>
      </div>
    </>
  );
};
